import {
  BO_CONSOL_FETCH_LIST_REQUEST,
  BO_CONSOL_FETCH_LIST_SUCCESS,
  BO_CONSOL_FETCH_LIST_FAILURE,
  BO_CONSOL_SELECT_BO,
  BO_CONSOL_SET_PHASE,
  BO_CONSOL_CLEAN_START,
  BO_CONSOL_CLEAN_PROGRESS,
  BO_CONSOL_CLEAN_COMPLETE,
  BO_CONSOL_CLEAN_ERROR,
  BO_CONSOL_FETCH_EXTRACTED_REQUEST,
  BO_CONSOL_FETCH_EXTRACTED_SUCCESS,
  BO_CONSOL_FETCH_EXTRACTED_FAILURE,
  BO_CONSOL_UPDATE_DOC_STATUS,
  BO_CONSOL_EXECUTE_START,
  BO_CONSOL_EXECUTE_PROGRESS,
  BO_CONSOL_EXECUTE_COMPLETE,
  BO_CONSOL_EXECUTE_ERROR,
  BO_CONSOL_RESET,
  BO_CONSOL_SET_LIST_PAGE,
  BO_CONSOL_SET_LIST_FILTER,
  BO_CONSOL_SET_LIST_SEARCH,
  BO_CONSOL_SET_LIST_LANGUAGE,
  BO_CONSOL_SET_LIST_DATE_RANGE,
  BO_CONSOL_SYNC_START,
  BO_CONSOL_SYNC_COMPLETE,
  BO_CONSOL_SYNC_ERROR,
  BO_CONSOL_PREVIEW_BULK_START,
  BO_CONSOL_PREVIEW_BULK_PROGRESS,
  BO_CONSOL_PREVIEW_BULK_COMPLETE,
  BO_CONSOL_PREVIEW_BULK_ERROR,
  BO_CONSOL_PREVIEW_SINGLE_START,
  BO_CONSOL_PREVIEW_SINGLE_COMPLETE,
  BO_CONSOL_PREVIEW_SINGLE_ERROR,
  BO_CONSOL_FETCH_PREVIEW_REQUEST,
  BO_CONSOL_FETCH_PREVIEW_SUCCESS,
  BO_CONSOL_FETCH_PREVIEW_FAILURE,
  BO_CONSOL_CONFIRM_PREVIEW_SUCCESS,
  BO_CONSOL_OPEN_PREVIEW,
  BO_CONSOL_CLOSE_PREVIEW,
} from '../actions/types'

const initialState = {
  boList: { data: [], loading: false, total: 0, page: 1, pageSize: 20, statusFilter: 'all', search: '', language: 'all', dateFrom: '', dateTo: '' },
  selectedBo: null,
  phase: 'select',
  cleaningProgress: { taskId: null, step: '', percent: 0, message: '', docsFound: 0, result: null },
  extractedDocs: { new: [], update: [], abroge: [], loading: false, total: 0 },
  executionProgress: { taskId: null, step: '', percent: 0, message: '', current: 0, total: 0, result: null },
  sync: { loading: false, result: null, error: null },
  consolidationPreview: {
    bulkLoading: false,
    bulkProgress: { step: '', percent: 0, message: '', current: 0, total: 0 },
    bulkResult: null,
    bulkError: null,
    currentDocId: null,    // doc whose preview modal is open
    fetchLoading: false,
    fetchError: null,
    byDocId: {},           // { [docId]: { target_html, merged_html, article_replacements, ... } }
    perDocLoading: {},     // { [docId]: bool } — true while single preview is computing
    perDocError: {},       // { [docId]: string }
  },
}

const updateDocInCategory = (docs, docId, validationStatus) =>
  docs.map((doc) => (doc.id === docId ? { ...doc, validation_status: validationStatus } : doc))

export default function boConsolidationReducer(state = initialState, action) {
  switch (action.type) {
    // ─── BO List ──────────────────────────────────────────────────────────
    case BO_CONSOL_FETCH_LIST_REQUEST:
      return { ...state, boList: { ...state.boList, loading: true } }
    case BO_CONSOL_FETCH_LIST_SUCCESS:
      return {
        ...state,
        boList: {
          ...state.boList,
          data: action.payload.items || action.payload.data || [],
          total: action.payload.total || 0,
          loading: false,
        },
      }
    case BO_CONSOL_FETCH_LIST_FAILURE:
      return { ...state, boList: { ...state.boList, loading: false } }

    case BO_CONSOL_SET_LIST_PAGE:
      return { ...state, boList: { ...state.boList, page: action.payload } }
    case BO_CONSOL_SET_LIST_FILTER:
      return { ...state, boList: { ...state.boList, statusFilter: action.payload, page: 1 } }
    case BO_CONSOL_SET_LIST_SEARCH:
      return { ...state, boList: { ...state.boList, search: action.payload, page: 1 } }
    case BO_CONSOL_SET_LIST_LANGUAGE:
      return { ...state, boList: { ...state.boList, language: action.payload, page: 1 } }
    case BO_CONSOL_SET_LIST_DATE_RANGE:
      return { ...state, boList: { ...state.boList, dateFrom: action.payload.dateFrom, dateTo: action.payload.dateTo, page: 1 } }

    // ─── Select BO ────────────────────────────────────────────────────────
    case BO_CONSOL_SELECT_BO:
      return { ...state, selectedBo: action.payload }
    case BO_CONSOL_SET_PHASE:
      return { ...state, phase: action.payload }

    // ─── Cleaning ─────────────────────────────────────────────────────────
    case BO_CONSOL_CLEAN_START:
      return {
        ...state,
        phase: 'cleaning',
        cleaningProgress: { ...initialState.cleaningProgress, taskId: action.payload },
      }
    case BO_CONSOL_CLEAN_PROGRESS:
      return {
        ...state,
        cleaningProgress: {
          ...state.cleaningProgress,
          step: action.payload.step,
          percent: action.payload.percent,
          message: action.payload.message,
          docsFound: action.payload.docsFound || state.cleaningProgress.docsFound,
        },
      }
    case BO_CONSOL_CLEAN_COMPLETE:
      return {
        ...state,
        phase: 'review',
        cleaningProgress: { ...state.cleaningProgress, step: 'complete', percent: 100, result: action.payload },
      }
    case BO_CONSOL_CLEAN_ERROR:
      return {
        ...state,
        phase: 'cleaning',
        cleaningProgress: { ...state.cleaningProgress, step: 'error', message: action.payload },
      }

    // ─── Extracted Documents ──────────────────────────────────────────────
    case BO_CONSOL_FETCH_EXTRACTED_REQUEST:
      return { ...state, extractedDocs: { ...state.extractedDocs, loading: true } }
    case BO_CONSOL_FETCH_EXTRACTED_SUCCESS:
      return {
        ...state,
        extractedDocs: {
          new: action.payload.new || [],
          update: action.payload.update || [],
          abroge: action.payload.abroge || [],
          loading: false,
          total: action.payload.total || 0,
        },
      }
    case BO_CONSOL_FETCH_EXTRACTED_FAILURE:
      return { ...state, extractedDocs: { ...state.extractedDocs, loading: false } }

    // ─── Update Doc Status ────────────────────────────────────────────────
    case BO_CONSOL_UPDATE_DOC_STATUS:
      return {
        ...state,
        extractedDocs: {
          ...state.extractedDocs,
          new: updateDocInCategory(state.extractedDocs.new, action.payload.docId, action.payload.validationStatus),
          update: updateDocInCategory(state.extractedDocs.update, action.payload.docId, action.payload.validationStatus),
          abroge: updateDocInCategory(state.extractedDocs.abroge, action.payload.docId, action.payload.validationStatus),
        },
      }

    // ─── Execution ────────────────────────────────────────────────────────
    case BO_CONSOL_EXECUTE_START:
      return {
        ...state,
        phase: 'executing',
        executionProgress: { ...initialState.executionProgress, taskId: action.payload },
      }
    case BO_CONSOL_EXECUTE_PROGRESS:
      return {
        ...state,
        executionProgress: {
          ...state.executionProgress,
          step: action.payload.step,
          percent: action.payload.percent,
          message: action.payload.message,
          current: action.payload.current || state.executionProgress.current,
          total: action.payload.total || state.executionProgress.total,
        },
      }
    case BO_CONSOL_EXECUTE_COMPLETE:
      return {
        ...state,
        phase: 'done',
        executionProgress: { ...state.executionProgress, step: 'complete', percent: 100, result: action.payload },
      }
    case BO_CONSOL_EXECUTE_ERROR:
      return {
        ...state,
        phase: 'review',
        executionProgress: { ...state.executionProgress, step: 'error', message: action.payload },
      }

    // ─── SGG Sync ─────────────────────────────────────────────────────────
    case BO_CONSOL_SYNC_START:
      return { ...state, sync: { loading: true, result: null, error: null } }
    case BO_CONSOL_SYNC_COMPLETE:
      return { ...state, sync: { loading: false, result: action.payload, error: null } }
    case BO_CONSOL_SYNC_ERROR:
      return { ...state, sync: { loading: false, result: null, error: action.payload } }

    // ─── Consolidation Preview ────────────────────────────────────────────
    case BO_CONSOL_PREVIEW_BULK_START:
      return {
        ...state,
        consolidationPreview: {
          ...state.consolidationPreview,
          bulkLoading: true,
          bulkProgress: { step: '', percent: 0, message: '', current: 0, total: 0 },
          bulkResult: null,
          bulkError: null,
        },
      }
    case BO_CONSOL_PREVIEW_BULK_PROGRESS:
      return {
        ...state,
        consolidationPreview: {
          ...state.consolidationPreview,
          bulkProgress: {
            step: action.payload.step,
            percent: action.payload.percent,
            message: action.payload.message,
            current: action.payload.current || state.consolidationPreview.bulkProgress.current,
            total: action.payload.total || state.consolidationPreview.bulkProgress.total,
          },
        },
      }
    case BO_CONSOL_PREVIEW_BULK_COMPLETE:
      return {
        ...state,
        phase: 'consolidation-preview',
        consolidationPreview: {
          ...state.consolidationPreview,
          bulkLoading: false,
          bulkResult: action.payload,
          bulkProgress: { ...state.consolidationPreview.bulkProgress, percent: 100, step: 'complete' },
        },
      }
    case BO_CONSOL_PREVIEW_BULK_ERROR:
      return {
        ...state,
        consolidationPreview: {
          ...state.consolidationPreview,
          bulkLoading: false,
          bulkError: action.payload,
        },
      }

    case BO_CONSOL_PREVIEW_SINGLE_START:
      return {
        ...state,
        consolidationPreview: {
          ...state.consolidationPreview,
          perDocLoading: { ...state.consolidationPreview.perDocLoading, [action.payload.docId]: true },
          perDocError: { ...state.consolidationPreview.perDocError, [action.payload.docId]: null },
        },
      }
    case BO_CONSOL_PREVIEW_SINGLE_COMPLETE:
      return {
        ...state,
        extractedDocs: {
          ...state.extractedDocs,
          update: updateDocInCategory(state.extractedDocs.update, action.payload.docId, 'previewed'),
        },
        consolidationPreview: {
          ...state.consolidationPreview,
          perDocLoading: { ...state.consolidationPreview.perDocLoading, [action.payload.docId]: false },
        },
      }
    case BO_CONSOL_PREVIEW_SINGLE_ERROR:
      return {
        ...state,
        extractedDocs: {
          ...state.extractedDocs,
          update: updateDocInCategory(state.extractedDocs.update, action.payload.docId, 'preview_failed'),
        },
        consolidationPreview: {
          ...state.consolidationPreview,
          perDocLoading: { ...state.consolidationPreview.perDocLoading, [action.payload.docId]: false },
          perDocError: { ...state.consolidationPreview.perDocError, [action.payload.docId]: action.payload.error },
        },
      }

    case BO_CONSOL_FETCH_PREVIEW_REQUEST:
      return {
        ...state,
        consolidationPreview: { ...state.consolidationPreview, fetchLoading: true, fetchError: null },
      }
    case BO_CONSOL_FETCH_PREVIEW_SUCCESS:
      return {
        ...state,
        consolidationPreview: {
          ...state.consolidationPreview,
          fetchLoading: false,
          byDocId: { ...state.consolidationPreview.byDocId, [action.payload.doc_id]: action.payload },
        },
      }
    case BO_CONSOL_FETCH_PREVIEW_FAILURE:
      return {
        ...state,
        consolidationPreview: { ...state.consolidationPreview, fetchLoading: false, fetchError: action.payload },
      }

    case BO_CONSOL_CONFIRM_PREVIEW_SUCCESS:
      return {
        ...state,
        extractedDocs: {
          ...state.extractedDocs,
          update: updateDocInCategory(state.extractedDocs.update, action.payload.docId, 'confirmed'),
        },
        consolidationPreview: {
          ...state.consolidationPreview,
          byDocId: action.payload.merged_html
            ? {
                ...state.consolidationPreview.byDocId,
                [action.payload.docId]: {
                  ...(state.consolidationPreview.byDocId[action.payload.docId] || {}),
                  merged_html: action.payload.merged_html,
                  validation_status: 'confirmed',
                },
              }
            : state.consolidationPreview.byDocId,
        },
      }

    case BO_CONSOL_OPEN_PREVIEW:
      return {
        ...state,
        consolidationPreview: { ...state.consolidationPreview, currentDocId: action.payload },
      }
    case BO_CONSOL_CLOSE_PREVIEW:
      return {
        ...state,
        consolidationPreview: { ...state.consolidationPreview, currentDocId: null },
      }

    // ─── Reset ────────────────────────────────────────────────────────────
    case BO_CONSOL_RESET:
      return initialState

    default:
      return state
  }
}
